import axios, { AxiosResponse } from "axios";
import { IDatosRespuesta } from "../interfaces/RespuestaDTO";
import { ProyectoAreaConocimientoDTO } from "../interfaces/ProyectoAreaConocimientoDTO";
import { ReporteProyectoPorUsuario } from "../interfaces/BusquedaPersonalDTO";
import { ResponceApi } from "../interfaces/Responses";
import { DetallesProyecto } from "../interfaces/DetallesProyecto";
import { ProyectoBusqueda } from "../interfaces/ProyectoBusqueda";
import { Option } from "../interfaces/ProyectosDTOS/Option";
import { CabeceraProyecto } from "../interfaces/CabeceraProyecto";
import { ProyectoDatosGenerales } from "../interfaces/ProyectosDatosGenerales";
import { InitialProyectoSolicitudDTO, ProyectoSolicitudDTO } from "../interfaces/Solicitud/ProyectoSolicitudDTO";
import { InformesInvestigador, InitialInformesInvestigador } from "../interfaces/Itinerario/InformesInvestigador";
import { PermisoDTO, VoidPermisoDTO } from "../interfaces/ProyectosDTOS/PermisoDTO";
const localBack: string = process.env.REACT_APP_BACK || '';
const APICATALOGO: string = '/api/Proyecto';

export default class ProyectoService {
    async GetColaboradoresProyectoById(id: number, token: any): Promise<ResponceApi<any>> {
        const response1: AxiosResponse<ResponceApi<any>> = await axios.get(localBack + APICATALOGO + '/GetColaboradoresProyecto/' + id,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
        //console.log(response1.data);        
        return response1.data;
    }

    async GetListODS(token: any): Promise<ResponceApi<any>> {
        const response1: AxiosResponse<ResponceApi<any>> = await axios.get(localBack + APICATALOGO + '/ListObjODS/',
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
        //console.log(response1.data);        
        return response1.data;
    }

    async GetDatosPersonalesColaborador(apellidos: string, email: string, token: any): Promise<ResponceApi<any>> {
        const response1: AxiosResponse<ResponceApi<any>> = await axios.get(localBack + APICATALOGO + '/GetDatosPersonalesColaborador/' + apellidos + '&' + email,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
        //console.log(response1.data);        
        return response1.data;
    }

    async GetAreasProyectoById(id: number, token: any): Promise<ResponceApi<ProyectoAreaConocimientoDTO>> {
        const response1: AxiosResponse<ResponceApi<ProyectoAreaConocimientoDTO>> = await axios.get(localBack + APICATALOGO + '/GetAreasProyecto/' + id,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
        //console.log(response1.data);        
        return response1.data;
    }

    async GetProyectoByEmailCedula(cedula: string, usuario: string, idunidad: number, token: any): Promise<ResponceApi<ReporteProyectoPorUsuario>> {
        const response1: AxiosResponse<ResponceApi<ReporteProyectoPorUsuario>> =
            await axios.get(localBack + APICATALOGO + '/GetProyectoByEmailCedula/' + cedula + '&' + usuario + '&' + idunidad,
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
        //console.log(response1.data);        
        return response1.data;
    }

    async GetProyectosByUser(usuario: string, token: any): Promise<ResponceApi<ProyectoBusqueda>> {
        const response1: AxiosResponse<ResponceApi<ProyectoBusqueda>> =
            await axios.get(localBack + APICATALOGO + '/GetProyectosByUsuario/' + usuario,
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
        //console.log(response1.data);        
        return response1.data;
    }

    async GenerarCertificadoParticipacion(cedula: string, idusuario: number, tipof: string, token: any): Promise<IDatosRespuesta<string>> {
        const response1: AxiosResponse<IDatosRespuesta<string>> =
            await axios.get(localBack + APICATALOGO + '/GenerarCertificadoColaboradores/' + cedula + '&' + idusuario + '&' + tipof,
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
        //console.log(response1.data);        
        return response1.data;
    }

    async GetDetalleProyectoById(idproyecto: number, token: any): Promise<ResponceApi<DetallesProyecto>> {
        const response1: AxiosResponse<ResponceApi<DetallesProyecto>> =
            await axios.get(localBack + APICATALOGO + '/GetDetalleProyectoById/' + idproyecto,
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
        //console.log(response1.data);        
        return response1.data;
    }

    async GetProyectoEnviadosByCodigo(codigo: string, token: any): Promise<ResponceApi<Option>> {
        const response1: AxiosResponse<ResponceApi<Option>> =
            await axios.get(localBack + APICATALOGO + '/GetProyectoEnviadosByCodigo/' + codigo,
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
        //console.log(response1.data);        
        return response1.data;
    }

    async GetProyectosByCodigo(codigo: string, token: any): Promise<ResponceApi<ProyectoBusqueda>> {
        const response1: AxiosResponse<ResponceApi<ProyectoBusqueda>> =
            await axios.get(localBack + APICATALOGO + '/GetProyectosByCodigo/' + codigo,
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
        //console.log(response1.data);        
        return response1.data;
    }

    async GetProyectosEnviadosByTitulo(titulo: string, token: any): Promise<ResponceApi<Option>> {
        const response1: AxiosResponse<ResponceApi<Option>> =
            await axios.get(localBack + APICATALOGO + '/GetProyectoEnviadosByTitulo/' + titulo,
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
        //console.log(response1.data);        
        return response1.data;
    }
    async GetProyectosEnviadosByUser(texto: string, token: any): Promise<ResponceApi<Option>> {
        const response1: AxiosResponse<ResponceApi<Option>> =
            await axios.get(localBack + APICATALOGO + '/ListUsuariosByNameOrUser/' + texto,
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
        //console.log(response1.data);        
        return response1.data;
    }

    async GetProyectosByTitulo(titulo: string, token: any): Promise<ResponceApi<ProyectoBusqueda>> {
        const response1: AxiosResponse<ResponceApi<ProyectoBusqueda>> =
            await axios.get(localBack + APICATALOGO + '/GetProyectosByTitulo/' + titulo,
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
        //console.log(response1.data);        
        return response1.data;
    }

    async GetProyectosByIdProyecto(id: number, token: any): Promise<ResponceApi<CabeceraProyecto>> {
        const response1: AxiosResponse<ResponceApi<CabeceraProyecto>> =
            await axios.get(localBack + APICATALOGO + '/GetProyecto/' + id,
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
        //console.log(response1.data);        
        return response1.data;
    }

    async GetProyectosDatosGeneralesByIdProyecto(id: number, token: any): Promise<ResponceApi<ProyectoDatosGenerales>> {
        const response1: AxiosResponse<ResponceApi<ProyectoDatosGenerales>> =
            await axios.get(localBack + APICATALOGO + '/GetProyectoDatosGenerales/' + id,
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
        //console.log(response1.data);        
        return response1.data;
    }
    async GetNuevaSolicitudProyectosByIdProyecto(id: number, token: any): Promise<ResponceApi<ProyectoSolicitudDTO>> {
        try {
            const response1: AxiosResponse<ResponceApi<ProyectoSolicitudDTO>> =
                await axios.get(localBack + APICATALOGO + '/GetNuevaSolicitudProyectosByIdProyecto/' + id,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    });
            //console.log(response1.data);        
            return response1.data;
        } catch (error) {
            console.error('Error al enviar la solicitud:', error);
            return {
                status: { isSuccessfully: false, messages: ['Error en la conexión a Api consulta'] },
                operation: 0,
                statusCode: 500,
                count: 0,
                listData: [],
                data: InitialProyectoSolicitudDTO(),
            };
        }
    }

    async GetProyectoSolicitudById(id: number, token: any): Promise<ResponceApi<ProyectoSolicitudDTO>> {
        try {
            const response1: AxiosResponse<ResponceApi<ProyectoSolicitudDTO>> =
                await axios.get(localBack + APICATALOGO + '/GetProyectoSolicitudById/' + id,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    });
            //console.log(response1.data);        
            return response1.data;
        } catch (error) {
            console.error('Error al enviar la solicitud:', error);
            return {
                status: { isSuccessfully: false, messages: ['Error en la conexión a Api consulta'] },
                operation: 0,
                statusCode: 500,
                count: 0,
                listData: [],
                data: InitialProyectoSolicitudDTO(),
            };
        }
    }

    async InformesPendientesProyectosEnEjec(idInv: number, token: any): Promise<ResponceApi<InformesInvestigador>> {
        try {
            const response1: AxiosResponse<ResponceApi<InformesInvestigador>> =
                await axios.get(localBack + APICATALOGO + '/InformesPendientesProyectosEnEjec/' + idInv,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    });
            //console.log(response1.data);        
            return response1.data;
        } catch (error) {
            console.error('Error al enviar la solicitud:', error);
            return {
                status: { isSuccessfully: false, messages: ['Error en la conexión a Api consulta'] },
                operation: 0,
                statusCode: 500,
                count: 0,
                listData: [],
                data: InitialInformesInvestigador(),
            };
        }
    }

    async ValidateEditProy(idpersona: number,idproyecto: number, token: any): Promise<ResponceApi<PermisoDTO>> {
        try {
            const response1: AxiosResponse<ResponceApi<PermisoDTO>> =
                await axios.get(localBack + APICATALOGO + '/ValidateEditProy/' + idpersona +'&'+ idproyecto,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    });
            //console.log(response1.data);        
            return response1.data;
        } catch (error) {
            console.error('Error al enviar la solicitud:', error);
            return {
                status: { isSuccessfully: false, messages: ['Error en la conexión a Api ValidateEditProy'] },
                operation: 0,
                statusCode: 500,
                count: 0,
                listData: [],
                data: VoidPermisoDTO(),
            };
        }
    }
}